// extracted by mini-css-extract-plugin
export default {"page":"AnalyticsPage_page__5+dVB","rightPanel":"AnalyticsPage_rightPanel__W-Jc0","analyticsWrapper":"AnalyticsPage_analyticsWrapper__1oeSG"};